import { Document as RichTextDocument } from '@contentful/rich-text-types';
import Grid2 from '@mui/material/Unstable_Grid2';

import { DialogContent } from '@/components/FormResultDialog/FormResultDialog';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import {
  FormOrientation,
  LeadForm,
} from '@/components/TopLevelComponents/LeadForm/LeadForm';
import { GoogleUrls } from '@/constants/baseUrls';
import { Contentful } from '@/contentful/types';
import { LeadFormType } from '@/enums/FormType';
import useViewPortSize from '@/hooks/useViewportSize';
import { ActionModalCF, LeadCreatedModalCF } from '@/types';
import { getLeadFormDialogContent } from '@/utils/leadForm';

import useStyles from './ActionUserInputHorizontal.styles';

export interface ActionUserInputHorizontalContent extends Contentful {
  fields: {
    heading?: string;
    termsOfService: RichTextDocument;
    submitButtonText?: string;
    isOnDark?: boolean;
    campaignId?: string;
    googleSheetUrls?: GoogleUrls;
    formType?: LeadFormType;
    dialogContent?: DialogContent;
    leadCreatedModal?: LeadCreatedModalCF | ActionModalCF;
    leadNotInServiceModal?: LeadCreatedModalCF | ActionModalCF;
    overrideCampaignId?: boolean;
  };
}

export interface ActionUserInputHorizontalProps {
  content: ActionUserInputHorizontalContent;
}

export default function ActionUserInputHorizontal({
  content: {
    fields: {
      heading,
      termsOfService,
      submitButtonText,
      isOnDark,
      campaignId,
      googleSheetUrls,
      formType,
      leadCreatedModal,
      leadNotInServiceModal,
      overrideCampaignId = false,
    },
  },
}: ActionUserInputHorizontalProps) {
  const { classes, cx } = useStyles({ isOnDark });
  const { isSmall, isExtraSmall } = useViewPortSize();
  const isMdOrLarger = !isExtraSmall && !isSmall;

  const successDialogContent = getLeadFormDialogContent(
    leadCreatedModal,
    isMdOrLarger
  );
  const failDialogContent = getLeadFormDialogContent(
    leadNotInServiceModal,
    isMdOrLarger
  );

  return (
    <SpacingContainer className={cx(classes.container)}>
      <GridContainer2 gridProps={{ className: classes.wrapper }} fixed>
        <Grid2 xs={12}>
          <LeadForm
            heading={heading}
            submitButtonText={submitButtonText}
            tcpa={termsOfService}
            orientation={FormOrientation.HORIZONTAL}
            isOnDark={isOnDark}
            campaignId={campaignId}
            googleSheetUrls={googleSheetUrls}
            formType={formType}
            successDialogContent={successDialogContent}
            failDialogContent={failDialogContent}
            overrideCampaignId={overrideCampaignId}
          />
        </Grid2>
      </GridContainer2>
    </SpacingContainer>
  );
}
